import * as React from "react";
import { useReducer, useEffect } from "react";
import { Row, Col, Button, Input } from 'reactstrap';
import GenericDropdown from './controls/GenericDropdown';
import { LookupItem } from "../Models/LookupItem";
import { ChapterArticle } from "../Models/ChapterArticle";
import ChaptersListingResults, { SearchFilter } from './ChaptersListingResult';
import FeaturedChapter from "./FeaturedChapter";
import { SpotlightItem } from "./Spotlight";
import Spotlight from "./Spotlight";
import * as Utils from '../Utils';

type OrderBy = 'date' | 'alpha';

type ChaptersListingState = {
    keywords: string;
    selectedCategory: LookupItem;
    selectedChapter: LookupItem;
    selectedYearMonth: LookupItem;
    searchFilter: SearchFilter;
    orderBy: OrderBy;
    initDone: boolean;
}

const initialState: ChaptersListingState = {
    keywords: '',
    selectedCategory: undefined,
    selectedChapter: undefined,
    selectedYearMonth: undefined,
    searchFilter: undefined,
    orderBy: 'date',
    initDone: false
}

const ChaptersListing = (props: {
    Path: string;
    Categories: LookupItem[];
    Chapters: LookupItem[];
    YearMonths: LookupItem[];
    BackgroundImage: string;
    Title: string;
    FeaturedArticle: ChapterArticle;
    Spotlights: SpotlightItem[];
    PreselectedChapterValue?: string;
    HeaderHtml?: string;
    IsLive: boolean
}) => {

    let [state, setState] = useReducer(
        (prevState: ChaptersListingState, Chapterstate: Partial<ChaptersListingState>) => ({ ...prevState, ...Chapterstate }),
        initialState
    );

    const search = () => {
        const sf: SearchFilter = {
            Category: state.selectedCategory ? state.selectedCategory.Value : undefined,
            
            YearMonth: state.selectedYearMonth ? state.selectedYearMonth.Value : undefined,
            Keywords: state.keywords,
            SortByField: state.orderBy,
            SortASC: false,
            Path: props.Path
        };

        setState({ searchFilter: sf });
    };

    const searchByCategory = (categoryId: string) => {

        let category = props.Categories.find(x => x.Value == categoryId);

        let sf: SearchFilter = {
            Category: category ? category.Value : undefined,            
            YearMonth: undefined,
            Keywords: '',
            SortByField: state.orderBy,            
            Path: props.Path
        };

        let newState: Partial<ChaptersListingState> = {
            selectedCategory: category,
            searchFilter: sf,
            selectedChapter: state.selectedChapter,
            selectedYearMonth: undefined,
            keywords: ''
        }

        setState(newState);

    }

    const clearFilters = () => {

        let sf: SearchFilter = {
            Category: undefined,
            YearMonth: undefined,
            Keywords: '',
            SortByField: state.orderBy,            
            Path: props.Path
        };

        setState({
            keywords: '',
            selectedCategory: undefined,
            selectedYearMonth: undefined,
            searchFilter: sf
        });
    }


    useEffect(() => {

        let hp: HashParams = {
            cat: state.selectedCategory ? state.selectedCategory.Title : undefined,            
            ym: state.selectedYearMonth ? state.selectedYearMonth.Value : undefined,
            q: state.keywords
        };

        if (state.initDone) {
            window.location.href = Utils.buildHash(hp);
        }

    }, [state.searchFilter]);

    useEffect(() => {

        let newState: Partial<ChaptersListingState> = {};

        if (props.PreselectedChapterValue && props.PreselectedChapterValue.length > 0) {
            newState.selectedChapter = props.Chapters.find(x => x.Value.toLowerCase() == props.PreselectedChapterValue.toLowerCase());
        }

        if (location.hash && location.hash.length > 2) {
            let urlParams = Utils.hashStringParse(location.hash) as HashParams;

            // set category
            if (urlParams.cat) {
                newState.selectedCategory = props.Categories.find(x => x.Title.toLowerCase() == urlParams.cat.toLowerCase());
            }

            // set keyword
            if (urlParams.q && urlParams.q.length > 0) {
                newState.keywords = urlParams.q;
            }

            // chapter
            //if (urlParams.chap)
            //    newState.selectedChapter = props.Chapters.find(x => x.Title.toLowerCase() == urlParams.chap.toLowerCase());

            // year month
            if (urlParams.ym)
                newState.selectedYearMonth = props.YearMonths.find(x => x.Value == urlParams.ym);
        }

        newState.initDone = true;
        newState.orderBy = 'date';

        newState.searchFilter = {
            Category: newState.selectedCategory ? newState.selectedCategory.Value : undefined,
            //Chapter: newState.selectedChapter ? newState.selectedChapter.Value : undefined,
            YearMonth: newState.selectedYearMonth ? newState.selectedYearMonth.Value : undefined,
            Keywords: newState.keywords,
            SortByField: newState.orderBy,
            Path: props.Path
        };

        setState(newState);

    }, []);

    // return
    return <div className="chapters-listing">
        <div className="full-width-content p-0">
            <div className="page-section py-0">
                <div className="chapter-filters-wrapper" style={{ backgroundImage: `url(${props.BackgroundImage})` }}>
                    <h1 className="title">{props.Title}</h1>
                    <div className="inline-filters d-flex flex-md-row flex-column flex-sm-column">
                        <div className="d-md-flex w-100">

                            <div className="dropdown-wrapper">
                                <div className="small dropdown-head-label">Select Chapter</div>
                                <GenericDropdown
                                    dataSource={props.Chapters}
                                    getId={x => x.Value}
                                    renderItem={x => x.Title}
                                    customItemWrapperRender={(x, key, children) => <a href={x.Value} key={key} className="menuitem d-block">{children}</a>}
                                    renderSelectedItem={x => x.Title}
                                    nullSelectionText="All Chapters"
                                    selectedValue={state.selectedChapter ? state.selectedChapter.Value : undefined}
                                    onSelectedItemChanged={x => setState({ selectedChapter: x })}
                                />
                            </div>

                            <GenericDropdown
                                dataSource={props.Categories}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                renderSelectedItem={x => x.Title}
                                nullSelectionText="All News & Events"
                                allowNullSelection={true}
                                selectedValue={state.selectedCategory ? state.selectedCategory.Value : undefined}
                                onSelectedItemChanged={x => setState({ selectedCategory: x })}
                            />

                            <GenericDropdown
                                dataSource={props.YearMonths}
                                getId={x => x.Value}
                                renderItem={x => x.Title}
                                renderSelectedItem={x => x.Title}
                                nullSelectionText="All Dates"
                                allowNullSelection={true}
                                selectedValue={state.selectedYearMonth ? state.selectedYearMonth.Value : undefined}
                                onSelectedItemChanged={x => setState({ selectedYearMonth: x })}
                            />

                            <div className="search">                                
                                <div className="input-group w-100">
                                    <div className="search-icon">
                                        <i className="fas fa-search"></i>
                                    </div>
                                    <Input onChange={(e) => { setState({ keywords: e.target.value }) }}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                search();
                                            }
                                        }}
                                        value={state.keywords}
                                        className="form-control"
                                        placeholder="Search for keywords and description" />

                                    <Button onClick={search}>Search</Button>
                                    <Button onClick={clearFilters} className="btn-clear">Clear Search</Button>
                                </div>                              
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
                {props.HeaderHtml && <div dangerouslySetInnerHTML={{ __html: props.HeaderHtml }}></div>}
            </div>
        </div>
        <div className="full-width-content pt-0">
            <div className="page-section pt-0">
                <div className="page-section-inner">
                    <Row>
                        <Col md={9}>
                            <ChaptersListingResults
                                searchFilter={state.searchFilter}
                                searchByCategory={searchByCategory}
                                isLive={props.IsLive}
                            />
                        </Col>
                        <Col md={3} className="pt-30">
                            {props.FeaturedArticle && <FeaturedChapter item={props.FeaturedArticle} />}
                            {(props.Spotlights || []).map((x, index) => <Spotlight item={x} key={index} />)}
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    </div>

}

export class HashParams {    
    cat: string;
    ym: string;
    q: string;
}

export default ChaptersListing;